/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Address,
  Contract,
  ContractState,
  TestContractResult,
  HexString,
  ContractFactory,
  EventSubscribeOptions,
  EventSubscription,
  CallContractParams,
  CallContractResult,
  TestContractParams,
  ContractEvent,
  subscribeContractEvent,
  subscribeContractEvents,
  testMethod,
  callMethod,
  multicallMethods,
  fetchContractState,
  Asset,
  ContractInstance,
  getContractEventsCurrentCount,
  TestContractParamsWithoutMaps,
  TestContractResultWithoutMaps,
  SignExecuteContractMethodParams,
  SignExecuteScriptTxResult,
  signExecuteMethod,
  addStdIdToFields,
  encodeContractFields,
  Narrow,
} from "@alephium/web3";
import { default as FullMathTestContractJson } from "../utils/FullMathTest.ral.json";
import { getContractByCodeHash, registerContract } from "./contracts";
import * as types from "./types";

// Custom types for the contract
export namespace FullMathTestTypes {
  export type State = Omit<ContractState<any>, "fields">;

  export interface CallMethodTable {
    mulDiv: {
      params: CallContractParams<{ a: bigint; b: bigint; denominator: bigint }>;
      result: CallContractResult<bigint>;
    };
  }
  export type CallMethodParams<T extends keyof CallMethodTable> =
    CallMethodTable[T]["params"];
  export type CallMethodResult<T extends keyof CallMethodTable> =
    CallMethodTable[T]["result"];
  export type MultiCallParams = Partial<{
    [Name in keyof CallMethodTable]: CallMethodTable[Name]["params"];
  }>;
  export type MultiCallResults<T extends MultiCallParams> = {
    [MaybeName in keyof T]: MaybeName extends keyof CallMethodTable
      ? CallMethodTable[MaybeName]["result"]
      : undefined;
  };
  export type MulticallReturnType<Callss extends MultiCallParams[]> = {
    [index in keyof Callss]: MultiCallResults<Callss[index]>;
  };

  export interface SignExecuteMethodTable {
    mulDiv: {
      params: SignExecuteContractMethodParams<{
        a: bigint;
        b: bigint;
        denominator: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
  }
  export type SignExecuteMethodParams<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["params"];
  export type SignExecuteMethodResult<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["result"];
}

class Factory extends ContractFactory<FullMathTestInstance, {}> {
  encodeFields() {
    return encodeContractFields({}, this.contract.fieldsSig, types.AllStructs);
  }

  consts = {
    FullMathError: { DivByZero: BigInt("350"), MulDivOverflow: BigInt("351") },
  };

  at(address: string): FullMathTestInstance {
    return new FullMathTestInstance(address);
  }

  tests = {
    mulDiv: async (
      params: Omit<
        TestContractParamsWithoutMaps<
          never,
          { a: bigint; b: bigint; denominator: bigint }
        >,
        "initialFields"
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(this, "mulDiv", params, getContractByCodeHash);
    },
  };

  stateForTest(initFields: {}, asset?: Asset, address?: string) {
    return this.stateForTest_(initFields, asset, address, undefined);
  }
}

// Use this object to test and deploy the contract
export const FullMathTest = new Factory(
  Contract.fromJson(
    FullMathTestContractJson,
    "",
    "fd74df789eb5974e11dfa74960ba1323e0530fe5e1fe0aa43a6c3c9bf9ee1d98",
    types.AllStructs
  )
);
registerContract(FullMathTest);

// Use this class to interact with the blockchain
export class FullMathTestInstance extends ContractInstance {
  constructor(address: Address) {
    super(address);
  }

  async fetchState(): Promise<FullMathTestTypes.State> {
    return fetchContractState(FullMathTest, this);
  }

  view = {
    mulDiv: async (
      params: FullMathTestTypes.CallMethodParams<"mulDiv">
    ): Promise<FullMathTestTypes.CallMethodResult<"mulDiv">> => {
      return callMethod(
        FullMathTest,
        this,
        "mulDiv",
        params,
        getContractByCodeHash
      );
    },
  };

  transact = {
    mulDiv: async (
      params: FullMathTestTypes.SignExecuteMethodParams<"mulDiv">
    ): Promise<FullMathTestTypes.SignExecuteMethodResult<"mulDiv">> => {
      return signExecuteMethod(FullMathTest, this, "mulDiv", params);
    },
  };

  async multicall<Calls extends FullMathTestTypes.MultiCallParams>(
    calls: Calls
  ): Promise<FullMathTestTypes.MultiCallResults<Calls>>;
  async multicall<Callss extends FullMathTestTypes.MultiCallParams[]>(
    callss: Narrow<Callss>
  ): Promise<FullMathTestTypes.MulticallReturnType<Callss>>;
  async multicall<
    Callss extends
      | FullMathTestTypes.MultiCallParams
      | FullMathTestTypes.MultiCallParams[]
  >(callss: Callss): Promise<unknown> {
    return await multicallMethods(
      FullMathTest,
      this,
      callss,
      getContractByCodeHash
    );
  }
}
